<div class="app-shell">

  <!-- Persistent Sidebar -->
  <aside class="project-sidebar" [class.collapsed]="sidebarCollapsed">
    <div class="sidebar-top">
      @if (!sidebarCollapsed) {
      <div class="sidebar-logo">
        <img width="110" alt="Tmeic" src="assets/images/Tmeic-logo.png" />
      </div>
      }
      <button class="hamburger-btn" type="button" (click)="toggleSidebar()" title="Toggle menu">
        <i class="ri-menu-line"></i>
      </button>
    </div>

    <a class="sidebar-back" routerLink="/projects">
      <i class="ri-arrow-left-line"></i>
      <i class="ri-briefcase-line"></i>
      <span class="menu-text">Projects</span>
    </a>

    @if (!sidebarCollapsed) {
    <div class="project-card">
      <div class="project-card-avatar">{{ projectName ? projectName.charAt(0) : 'P' }}</div>
      <div class="project-card-text">
        <p class="project-card-label">{{projectInfo?.projectNumber}}</p>
        <p title="{{projectInfo?.projectNumber}} - {{ projectName }}" class="project-card-name">{{ projectName }}</p>
      </div>
    </div>
    }
    @if (sidebarCollapsed) {
    <div class="project-card-collapsed">
      <div class="project-card-avatar">{{ projectName ? projectName.charAt(0) : 'P' }}</div>
      <span title="{{projectInfo?.projectNumber}} - {{ projectName }}" class="menu-text">{{ projectName }}</span>
    </div>
    }

    @if (!sidebarCollapsed) {
    <div class="sidebar-section-label">PROJECT</div>
    }

    <div class="sidebar-menu">
      @if (menuReady()) {
      <ul class="menu-list">
        @for (item of projectMenuItems; track item) {
        <li class="menu-item">
          <a [routerLink]="item.routerLink" class="menu-link" routerLinkActive="active-menu-link"
            [routerLinkActiveOptions]="{exact: false}">
            <i class="{{ item.icon }}"></i>
            <span class="menu-text">{{ item.label }}</span>
          </a>
        </li>
        }
      </ul>
      }
    </div>

    <button class="menu-link logout-link" type="button" (click)="onLogout()">
      <i class="ri-logout-circle-r-line"></i>
      <span class="menu-text">Logout</span>
    </button>
  </aside>

  <!-- Main Content -->
  <div class="app-main">
    <div class="toolbar">
      <app-top-menu></app-top-menu>
    </div>
    <div class="project-content">
      <router-outlet></router-outlet>
    </div>
  </div>

  <app-chat-bubble></app-chat-bubble>

</div>
